import { Skeleton } from '@common/components';

const CardSkeleton = () => (
  <div className="h-58 flex-1 rounded-large bg-Gray-white px-20 py-16 shadow-[8px_10px_40px_0px_rgba(0,0,0,0.03)] mobile-sm:h-[77.2px]">
    <Skeleton className="h-22 w-48 rounded-xsmall mobile-sm:h-40" />
  </div>
);

export const PersonalizedSectionSkeleton = () => {
  return (
    <section className="px-20 pb-4">
      <div className="flex gap-8">
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </section>
  );
};
